module.exports = __webpack_public_path__ + "static/media/BD.06a88a30.wav";